var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox check-success"},[_c('input',{attrs:{"id":_vm.id,"type":"checkbox"},domProps:{"checked":_vm.value},on:{"input":_vm.onChanged}}),_c('label',{staticClass:"form-check-label",class:{
    'text-danger': _vm.value === undefined && _vm.highlightError
  },attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }